import {UserRole} from "@/shared/enums/UserRolesEnums";
import FinishedPrivateCoachingList from "@/views/App/Analytics/FinishedCoaching/PrivateCoaching/List.vue";
import FinishedAssistedLivingCoachingList from "@/views/App/Analytics/FinishedCoaching/AssistedLivingCoaching/List.vue";
import AnalyticsDefaultView from "@/views/App/Analytics/AnalyticsDefaultView.vue";

const routesAnalyticsFinishedCoaching = [
    {
        path: "finished_coaching/",
        name: "analyticsFinishedCoaching",
        component: AnalyticsDefaultView,
        children: [
            {
                path: "private-coaching-list",
                name: "analyticsFinishedPrivateCoachingList",
                component: FinishedPrivateCoachingList,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.SITE_SUPPORT,
                        UserRole.SITE_MANAGER,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ACCOUNTANT,
                        UserRole.ASSISTANT_VQ,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                    ]
                },
            },
            {
                path: "assisted-living-coaching-list",
                name: "analyticsFinishedAssistedLivingCoachingList",
                component: FinishedAssistedLivingCoachingList,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.SITE_SUPPORT,
                        UserRole.SITE_MANAGER,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ACCOUNTANT,
                        UserRole.ASSISTANT_VQ,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                    ]
                },
            }
        ],
    },
   
]

export default routesAnalyticsFinishedCoaching;